module.exports = __webpack_public_path__ + "img/CM-JRF-25-GMC-Lifestyle.b1b4116a.jpg";